const enTranslation = require('./en.json')
const enSurveyTranslation = require('./enSurveys.json')

const newTranslation = { ...enSurveyTranslation, ...enTranslation }

export default newTranslation
